import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'yi',
    fullName: 'Yiddish',
    nativeName: 'ייִדיש',
    direction: 'rtl'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "עפּעס אַמייזינג איז קומענדיק",
    landing_subtitle: "ArgVoid איז אַן אַפּ און שפּיל אַנטוויקלונג סטודיע. בלייבן טונד, נייַע טינגז קומען באַלד!",
    select_language: "אויסקלייַבן שפּראַך",
    search_placeholder: "זוך שפראכן...",
    terms_title: "תּנאָים פון סערוויס",
    policy_title: "פּריוואַטקייט פּאָליטיק",
    cookies_title: "קיכל פּאָליטיק",
    terms_content: `
        <strong>1. אַקסעפּטאַנס פון טערמינען</strong><br>
        דורך אַקסעס ArgVoid, די תּנאָים פון סערוויס זענען אנגענומען. אויב די טערמינען זענען נישט מסכים, די דינסט זאָל ניט זיין געוויינט.<br><br>

        <strong>2. Platform Usage</strong><br>
        ArgVoid און זייַן אַפּלאַקיישאַנז זענען צוגעשטעלט "ווי איז" פֿאַר ינפאָרמאַטיוו און שעפעריש צוועקן. די דינסט מוזן זיין געניצט בלויז פֿאַר לעגאַל צוועקן.<br><br>

        <strong>3. פּראָוכיבאַטאַד קאָנדוקטקס11קס12קס
        די נוצן פון פּלאַץ וואַלנעראַביליטיז, ספּאַממינג אָדער פּרווון אַנאָטערייזד אַקסעס צו די ינפראַסטראַקטשער איז שטרענג פּראָוכיבאַטאַד.<br><br>

        <strong>4. אָפּלייקענונג</strong><br>
        די פּלאַטפאָרמע און באַדינונגס קענען זיין מאַדאַפייד אין קיין צייט אָן באַמערקן. קיין וואָראַנטי איז צוגעשטעלט וועגן די ופּטימע אָדער אַוויילאַבילאַטי פון די סערוויס.
    `,
    policy_content: `
        <strong>1. אינפֿאָרמאַציע זאַמלונג</strong><br>
        דער פּלאַטפאָרמע טוט נישט דאַרפן באַניצער אָטענטאַקיישאַן אָדער חשבון שאַפונג אין דעם צייט. קיין פערזענלעכע ידענטיפיינג אינפֿאָרמאַציע (אַזאַ ווי נעמען אָדער בליצפּאָסט אַדרעסעס) איז אַקטיוולי געזאמלט פון וויזאַטערז.<br><br>

        <strong>2. באַניץ Data</strong><br>
        יקערדיק, אַנאָנימייזד אַנאַליטיקס קען זיין געזאמלט צו פֿאַרשטיין פּלאַץ פאַרקער און פֿאַרבעסערן די אַפּלאַקיישאַנז. די דאַטן זענען נישט לינגקט צו יחיד באַניצער אידענטיטעט.<br><br>

        <strong>3. דריט-פּאַרטיי באַדינונגס </strong><br>
        דריט-פּאַרטיי פּראַוויידערז קען זיין געוויינט פֿאַר האָסטינג און אַנאַליטיקס באַדינונגס. די פּריוואַטקייט פּראַקטיסיז פון די ריספּעקטיוו פּראַוויידערז רעגירן די אַנאָנימע באַנוצערס דאַטן פּראַסעסט אויף זייער ינפראַסטראַקטשער.<br><br>

        <strong>4. Data Security</strong><br>
        גלייַך זיכערהייט מיטלען זענען ימפּלאַמענאַד צו באַשיצן די פּלאַטפאָרמע. אָבער, קיין אופֿן פון טראַנסמיסיע איבער די אינטערנעט איז לעגאַמרע זיכער.<br><br>
    `,
    cookies_content: `
        <strong>1. וואָס זענען קיכלעך און לאקאלע סטאָרידזש? </strong><br>
        קיכלעך און בלעטערער היגע סטאָרידזש זענען קליין דאַטן טעקעס סטאָרד אויף די מיטל צו געדענקען קאַנפיגיעריישאַן פּרעפֿערענצן פֿאַר וויזיץ.<br><br>

        <strong>2. באַניץ ציל</strong><br>
        בלעטערער לאָקאַלסטאָרידזש איז שטרענג געניצט צו ראַטעווען קאַנפיגיעריישאַן סעטטינגס, אַזאַ ווי: <br>
        - שפּראַך פּרעפֿערענצן <br>
        - באַניצער צובינד קאַנפיגיעריישאַן (למשל, אויסלייג אָדער טעמע סעטטינגס) <br>
        - צייטווייליגע אַפּלאַקיישאַן קאַש<br><br>

        <strong>3. קיין טראַקינג</strong><br>
        קיכלעך און היגע סטאָרידזש זענען נישט געניצט פֿאַר גאַנצע אָדער דריט-פּאַרטיי טראַקינג צוועקן. כל סטאָרד דאַטע איז שטרענג פֿאַר די האַרץ פאַנגקשאַנאַליטי פון די פּלאַטפאָרמע.<br><br>

        <strong>4. קאָנטראָלקס19קס20קס
        בלעטערער דאַטן קענען זיין קלירד אין קיין צייט דורך די בלעטערער סעטטינגס, וואָס וועט באַשטעטיק קיין היגע קאַנפיגיעריישאַנז.
    `,
    cookie_consent_text: "מיר נוצן יקערדיק קיכלעך צו ענשור אַז די וועבזייטל פאַנגקשאַנז ריכטיק, אַזאַ ווי האַלטן דיין סעסיע אַקטיוו, שפּאָרן דיין שפּראַך ייבערהאַנט און אנדערע מנהג קאַנפיגיעריישאַנז.",
    read_policy: "לייענען קיכל פּאָליטיק",
    support_title: "קאָנטאַקט שטיצן",
    support_subject_label: "טעמע",
    support_message_label: "אָנזאָג",
    support_submit_button: "שיקן אָנזאָג",
    support_hint: "באַמערקונג: דאָס וועט עפענען דיין פעליקייַט E- בריוו אַפּלאַקיישאַן צו שיקן דעם אָנזאָג.",
    support_success_msg: "עפֿענען דיין אימעיל אַפּ ...",
    support_error_msg: "ניט אַנדערש צו שיקן אָנזאָג. ביטע פּרובירן ווידער שפּעטער.",
    explorer_title: "Explorer",
    history_title: "געשיכטע",
    animation_title: "אַנאַמיישאַן",
    config_title: "קאָנפיגוראַטיאָן",
    tool_mouse: "אויסקלייַבן (Ctrl+M)",
    tool_brush: "באַרשט (Ctrl+B)",
    tool_brush_mode: "טאַגאַל מאָדע (האַרט / קלאָר)",
    tool_eraser: "מעקער (Ctrl+E)",
    tool_brush_size: "סטרויערן באַרשט גרייס",
    tool_bucket: "פּלאָמבירן (Ctrl+F)",
    tool_eyedropper: "ייעדראַפּפּער",
    tool_grid: "גריד (Ctrl + Shift + B)",
    tool_rotate: "דרייען (Ctrl+Shift+R)",
    tool_flip_h: "פליפּ H (Ctrl+Shift+H)",
    tool_flip_v: "פליפּ V (Ctrl+Shift+V)",
    tool_transpose: "טראַנספּאָסע (Ctrl+Shift+T)",
    label_width: "ברייט",
    label_height: "הייך",
    label_frames: "נומער פון ראָמען",
    label_animation: "אַנאַמיישאַן סטייל",
    label_background_color: "הינטערגרונט קאָליר",
    label_interval: "ינטערוואַל",
    tool_anim_config: "אַנאַמיישאַן קאָנפיגוראַטיאָן",
    label_new_width: "ניו ברייט",
    label_new_height: "ניו הייך",
    label_apply: "צולייגן",
    label_colors: "קאָלאָרס",
    label_size: "גרייס",
    label_tolerance: "טאָלעראַנץ",
    val_horizontal: "האָריזאָנטאַל",
    val_vertical: "ווערטיקאַל",
    val_sequence: "סיקוואַנס",
    val_bounce: "אָפּשפּרונג",
    val_random: "טראַפ",
    val_solid: "האַרט",
    val_clear: "קלאָר",
    action_add_sheet: "ניו בלאַט",
    action_import: "אַרייַנפיר",
    action_export: "עקספּאָרט",
    action_sort_projects: "סאָרט",
    sort_date_old: "אָולדאַסט ערשטער",
    sort_date_new: "נואַסט ערשטער",
    sort_name_az: "נאָמען (A-Z)",
    sort_name_za: "נאָמען (ז-א)",
    action_new_sprite: "ניו ספּרייט",
    action_new_project: "ניו פּראָיעקט",
    modal_save_all_title: "היט אַלע ענדערונגען",
    modal_save_all_desc: "אויסקלייַבן די אַסעץ צו ראַטעווען:",
    modal_save_selected: "היט אויסגעקליבן",
    action_saved: "געראטעוועט",
    modal_create_sprite_title: "שאַפֿן ניו ספּרייט",
    modal_create_project_title: "שאַפֿן ניו פּראָיעקט",
    modal_add_sheet_title: "לייג אַ נייַ בלאַט",
    modal_rename_sheet_title: "רענאַמע בלאַט",
    modal_rename_sprite_title: "רענאַמע ספּרייט",
    modal_delete_sprite_title: "ויסמעקן ספּרייט",
    modal_delete_project_title: "ויסמעקן פּראָיעקט",
    modal_delete_sheet_title: "ויסמעקן בלאַט",
    placeholder_sprite_name: "נאָמען",
    placeholder_project_name: "נאָמען",
    placeholder_sheet_name: "נאָמען",
    placeholder_new_name: "ניו נאָמען",
    action_create: "שאַפֿן",
    action_add: "לייג",
    action_rename: "רענאַמע",
    action_duplicate: "דופּליקאַט",
    action_delete: "ויסמעקן",
    action_cancel: "באָטל מאַכן",
    confirm_delete_sprite: "זענט איר זיכער אַז איר ווילן צו ויסמעקן דעם ספּרייט?",
    confirm_delete_project: "זענט איר זיכער אז איר ווילט אויסמעקן דעם פראיעקט? אַלע ספּריטעס וועט זיין אַוועקגענומען.",
    confirm_delete_sheet: "זענט איר זיכער אַז איר ווילן צו ויסמעקן דעם בלאַט?",
    err_select_sprite: "ביטע אויסקלייַבן אַ ספּרייט ערשטער.",
    err_select_project: "ביטע אויסקלייַבן אַ פּרויעקט ערשטער.",
    err_name_empty: "נאָמען קען נישט זיין ליידיק.",
    err_sprite_exists: "א ספּרייט מיט דעם נאָמען שוין יגזיסץ.",
    err_project_exists: "א פראיעקט מיט דעם נאמען עקזיסטירט שוין.",
    err_no_content: "קיין אינהאַלט צו ראַטעווען.",
    err_no_changes: "קיין ענדערונגען צו ראַטעווען.",
    err_delete_last_sheet: "קענען ניט ויסמעקן די לעצטע בלאַט.",
    err_extract_frames: "קען נישט עקסטראַקט קיין ראָמען.",
    err_indexeddb: "ניט אַנדערש צו ראַטעווען לאָוקאַלי. דיין בלעטערער קען נישט שטיצן IndexedDB.",
    msg_upload_success: "צופֿעליקער געראָטן: {0}",
    msg_upload_failed: "צופֿעליקער דורכפֿאַלן: {0}",
    msg_save_success: "היט געראָטן.",
    msg_saving: "שפּאָרן...",
    msg_multi_save_result: "געראטעוועט {0} אַסעץ. {1} פייליערז.",
    menu_title: "מעניו",
    menu_save: "היט",
    menu_save_all: "היט אַלע",
    menu_support: "קאָנטאַקט שטיצן",
    label_local_storage: "לאקאלע סטאָרידזש",
    label_sign_in: "צייכן אין",
    modal_export_title: "עקספּאָרט ספּרייט",
    label_filename: "טעקע נאָמען",
    label_format: "פֿאָרמאַט",
    action_export_confirm: "עקספּאָרט",
};

export default translations;
